import { css } from "@linaria/core";
import { units, fonts, colors, breakpoints } from "@pm2/compat";

export const wrapper = css`
  min-height: ${units.px(30)};

  display: flex;
  align-items: center;
`;

export const iconButton = css`
  margin-right: ${units.px(5)};
`;

export const progressText = css`
  margin-left: ${units.px(25)};

  height: ${units.px(13)};

  display: block;
  flex-shrink: 0;

  font-family: ${fonts.body({ weight: "bold" })};
  font-size: ${units.font.px(14)};
  line-height: ${fonts.lineHeight(1)};

  & > span:first-child {
    position: relative;

    margin-right: ${units.px(11)};
    padding-right: ${units.px(7)};

    &::after {
      content: "";

      position: absolute;
      top: ${units.px(2)};
      right: 0;
      bottom: ${units.px(2)};

      width: ${units.px(1)};

      background: ${colors.black()};
    }
  }

  @media ${breakpoints.mobile.andDown().toQuery()} {
    margin-left: ${units.px(8)};
    font-size: ${units.px(10)};

    & > span:first-child {
      margin-right: ${units.px(6)};
      padding-right: ${units.px(5)};
    }

    & > span:last-child {
      color: ${colors.text.secondary()};
    }
  }
`;

export const playIcon = css`
  fill: none;
  stroke: currentColor;
`;

export const loader = css`
  height: ${units.px(18)};
  width: ${units.px(18)};

  animation: rotate 900ms linear infinite;

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  /**
   * render spinner using pseudo elements so we can apply opacity on the track
   * (::before) while having a fully opaque thumb.
   */
  &::before,
  &::after {
    content: "";

    position: absolute;
    inset: 0;

    border: ${units.px(2)} solid transparent;
    border-radius: 50%;
  }

  &::before {
    border-color: currentColor;
    border-top-color: transparent;

    opacity: 0.05;
  }

  &::after {
    border-top-color: currentColor;
  }
`;
